// extracted by mini-css-extract-plugin
module.exports = {"termsWrapper":"Terms_termsWrapper___HBRz","termsContainer":"Terms_termsContainer__1TtwZ","termsContent":"Terms_termsContent__2WoKj","checkboxTerms":"Terms_checkboxTerms__ljqCS"};